/**
 * Computes the display canvas pixel dimensions to match PandaView's ThumbnailCropCords
 * output for uncropped photos (the common case in the prints builder).
 *
 * Mirrors getDefaultCropRatio: picks whichever of (printRatio, 1/printRatio) gives the
 * largest crop area. For a landscape photo (w >= h) that is always max(R, 1/R) ≥ 1;
 * for a portrait photo it is always min(R, 1/R) ≤ 1.  Uses Math.max/min rather than
 * importing getDefaultCropRatio directly because getDefaultCropRatio breaks ties toward
 * 1/ratio (portrait), while for square photos (w === h, equal crop areas) we want
 * landscape — consistent with the h <= w orientation class on .preview.
 *
 * Matching these dimensions ensures the blurhash canvas is the same CSS display size as the
 * PandaView canvas it replaces, so the transition is seamless.
 */
export const computeDisplaySize = (rawDimensions, sizeArea) => {
  const printRatio =
    sizeArea && sizeArea.length >= 2 && sizeArea[1] > 0
      ? sizeArea[0] / sizeArea[1]
      : null;

  if (
    rawDimensions &&
    rawDimensions.w > 0 &&
    rawDimensions.h > 0 &&
    printRatio
  ) {
    const isLandscapePhoto = rawDimensions.w >= rawDimensions.h;
    const effectiveRatio = isLandscapePhoto
      ? Math.max(printRatio, 1 / printRatio)
      : Math.min(printRatio, 1 / printRatio);

    if (effectiveRatio >= 1) {
      return {
        width: 600,
        height: Math.max(1, parseInt(600 / effectiveRatio, 10)),
      };
    }
    return {
      width: Math.max(1, parseInt(600 * effectiveRatio, 10)),
      height: 600,
    };
  }

  // Fallback when sizeArea is unavailable: use the photo's own aspect ratio.
  if (rawDimensions && rawDimensions.w > 0 && rawDimensions.h > 0) {
    const { w, h } = rawDimensions;
    if (w > h) {
      return { width: 600, height: Math.max(1, parseInt(600 * (h / w), 10)) };
    }
    return { width: Math.max(1, parseInt(600 * (w / h), 10)), height: 600 };
  }

  return { width: 600, height: 600 };
};
